export default {
      id: "color_charts_white-usage",
      viewBox: "0 0 175 96",
      url: __webpack_public_path__ + "sprite.svg#color_charts_white",
      toString: function () {
        return this.url;
      }
    }